import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";

const LOGO_URL =
  "https://res.cloudinary.com/jqvef0es/image/upload/v1783186298/logo_negativo_vbr4dg.svg";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative border-t border-divider">
      {/* Big brand block */}
      <div className="px-6 md:px-10 py-14 md:py-20 border-b border-divider">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ type: "spring", stiffness: 100, damping: 15 }}
          className="grid grid-cols-12 items-center gap-8"
        >
          <div className="col-span-12 md:col-span-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-rust mb-6">
              [04] Contacto
            </div>
            <img
              src={LOGO_URL}
              alt="Asombro"
              data-testid="footer-logo"
              className="w-full max-w-[820px] h-auto"
            />
          </div>

          <div className="col-span-12 md:col-span-4 flex flex-col gap-4">
            <a
              href="https://www.instagram.com/asombrofilms"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="group flex items-center justify-between border-b border-divider py-4 hover:text-rust transition-colors"
            >
              <span className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em]">
                <Instagram size={14} /> @asombrofilms
              </span>
              <ArrowUpRight
                size={16}
                className="text-white/40 group-hover:text-rust transition-colors"
              />
            </a>
            <a
              href="https://wa.me/595972919569"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="group flex items-center justify-between border-b border-divider py-4 hover:text-rust transition-colors"
            >
              <span className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em]">
                <span className="inline-block w-[14px] h-[14px] rounded-full bg-rust" />
                WhatsApp · +595 972 919569
              </span>
              <ArrowUpRight
                size={16}
                className="text-white/40 group-hover:text-rust transition-colors"
              />
            </a>
          </div>
        </motion.div>
      </div>

      {/* Terminal bar */}
      <div className="px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/60">
          <span className="text-rust">ASOMBRO</span> / Donde las ideas se vuelven memorables.
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 flex items-center gap-4">
          <span>© {year} Asombro Films</span>
          <span className="w-1 h-1 bg-white/40 rounded-full" />
          <span>Asunción · Paraguay</span>
        </div>
      </div>
    </footer>
  );
};
